/**
 * Configuration for offline network status management
 */

/**
 * Maximum number of offline retry attempts before pausing
 */
export const MAX_OFFLINE_ATTEMPTS = 5;

/**
 * Delay between offline retry pauses (30 minutes in milliseconds)
 */
export const OFFLINE_RETRY_DELAY = 1800000;

/**
 * Max events in the offline in-memory buffer
 */
export const MAX_BUFFER_SIZE = 500;

/**
 * Max age for offline events before purging in SW (7 days in milliseconds)
 */
export const OFFLINE_EVENT_MAX_AGE = 7 * 24 * 60 * 60 * 1000;
